import React, { Fragment } from "react";

import Grid from "@mui/material/Grid";
import LoginComponent from "../component/app/login/Login.component";
import LoginBackup from "../component/app/login/dialog/dialogBody/loginBackup";

const LoginPage = () => {
  return (
    <Fragment>
      <Grid container sx={{ height: "100vh", backgroundColor: "#fafffc" }}>
        <Grid md={4} />
        <Grid
          item
          md={4}
          xs={12}
          sx={{
            height: "100vh",
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <LoginComponent />
          {/* <LoginBackup /> */}
        </Grid>
        <Grid md={4} />
      </Grid>
    </Fragment>
  );
};

export default LoginPage;
